export default __webpack_public_path__ + "static/media/CERT2.fd44775e.png";